module.exports = __webpack_public_path__ + "img/visa.7f107093.svg";